import LoadingSpinner from "@/components/LoadingSpinner";
import { SiteContext } from "@/context/SiteContext";
import useApi from "@/hooks/useApi";
import { Site } from "@/types";
import React, { useState } from "react";

export function SiteProvider(props: { children: React.ReactNode }) {
  const [site, setSite] = useState<Site>({
    id: 0,
    companyName: "unknown"
  });

  const [loading, setLoading] = React.useState(true);
  const api = useApi();

  React.useEffect(() => {
    async function load() {
      try {
        const response = await api.admin.get("api/SiteSettings"); // Call our SiteSettingsController
        const siteData = await response.json();
        setSite(siteData);
      } catch (error) {
        console.error("Failed to load site data:", error);
        setSite({
          id: 0,
          companyName: "unknown"
        });
      } finally {
        setLoading(false);
      }
    }

    load();
  }, [api]);

  if (loading) {
    return <LoadingSpinner />;
  }

  return (
    <SiteContext.Provider value={{ site }}>
      {props.children}
    </SiteContext.Provider>
  );
}
